import React from "react";

const PaymentCancelPage = () => {
  return (
    <div>
      <h2>Payment was cancelled</h2>
      <p>You can try again later or contact support.</p>
    </div>
  );
};

export default PaymentCancelPage;